// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ArtSelectionModel } from "@store/Framework/Types/ApiModels";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { useEffect, useState } from "react";

export interface ProductArtSelectionProps extends ExpandStyles<ProductArtSelectionStyles> {}

export interface ProductArtSelectionStyles {
    wrapper?: InjectableCss;
    artSelectionSelect?: SelectProps;
}

export const artSelectionStyles: ProductArtSelectionStyles = {};

type Props = ProductArtSelectionProps & HasProductContext;

const ProductArtSelection: React.FC<Props> = ({ productContext, extendedStyles, overridedStyles }) => {
    const baseStyles = useExpandProps(artSelectionStyles, extendedStyles, overridedStyles);

    const { product, onArtSelectionChanged, selectedArtId } = productContext;
    const { properties } = product;

    const [artSelections, setArtSelections] = useState<ArtSelectionModel[]>();
    const [artSelection, setArtSelection] = useState<ArtSelectionModel>();

    if (!properties || !properties.artSelections) {
        return null;
    }

    useEffect(() => {
        const _artSelections = JSON.parse(properties.artSelections);
        setArtSelections(_artSelections);
    }, [properties]);

    useEffect(() => {
        if (artSelections && !artSelection) {
            const _artSelection =
                artSelections.find(a => a.id === selectedArtId) ||
                artSelections.find(a => !a.isNew) ||
                artSelections.find(a => a.isNew);

            if (_artSelection) {
                setArtSelection(_artSelection);
                onArtSelectionChanged?.(_artSelection.id);
            }
        }
    }, [artSelections]);

    const artSelectionChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedArt = artSelections?.find(a => a.id === event.target.value);
        setArtSelection(selectedArt);
        if (selectedArt?.id) {
            onArtSelectionChanged?.(selectedArt.id);
        }
    };

    return (
        <StyledWrapper {...baseStyles.wrapper} data-test-selector="product_artSelection">
            <Select
                {...baseStyles.artSelectionSelect}
                label={translate("Art Selection")}
                value={artSelection?.id}
                onChange={artSelectionChangeHandler}
                data-test-selector="product_artSelectionSelect"
            >
                {artSelections?.map(artS => (
                    <option value={`${artS.id}`} key={`${artS.id}`}>
                        {artS.name}
                    </option>
                ))}
            </Select>
        </StyledWrapper>
    );
};

export default withProductContext(ProductArtSelection);
